import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="border-t border-white/5 py-12 px-4">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <h3 className="text-lg font-bold bg-gradient-to-r from-[#FF3366] to-[#FF6B4D] bg-clip-text text-transparent mb-3">
              UIQuarter
            </h3>
            <p className="text-sm text-[#B4A5BD] leading-relaxed">
              Static analysis CLI for UI codebases. Component patterns, dependency graphs, and AI context generation.
            </p>
          </div>

          {/* Links */}
          <div>
            <h4 className="text-sm font-semibold text-white mb-3">Links</h4>
            <ul className="space-y-2">
              <li><Link to="/docs" className="text-sm text-[#B4A5BD] hover:text-white transition-colors">Documentation</Link></li>
              <li><Link to="/about" className="text-sm text-[#B4A5BD] hover:text-white transition-colors">About</Link></li>
              <li>
                <a href="https://github.com/fuatkeles/uiquarter" target="_blank" rel="noopener noreferrer" className="text-sm text-[#B4A5BD] hover:text-white transition-colors">
                  GitHub
                </a>
              </li>
              <li>
                <a href="https://www.npmjs.com/package/uiquarter" target="_blank" rel="noopener noreferrer" className="text-sm text-[#B4A5BD] hover:text-white transition-colors">
                  npm
                </a>
              </li>
            </ul>
          </div>

          {/* Install */}
          <div>
            <h4 className="text-sm font-semibold text-white mb-3">Quick Install</h4>
            <div className="rounded-lg bg-[#0D0D12] border border-white/5 p-3 font-mono text-sm">
              <span className="text-[#FF3366]">$</span>{' '}
              <span className="text-[#B4A5BD]">npm install -g uiquarter</span>
            </div>
          </div>
        </div>

        <div className="border-t border-white/5 pt-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-[#B4A5BD]">MIT License</p>
          <p className="text-xs text-[#B4A5BD]">
            Built with TypeScript. 20 analyzers. 500+ tests.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
